import styled from 'styled-components';

export const Info = styled.div`
  display: flex;
  flex: 1;
  margin: 0 10px;
  align-items: center;
  justify-content: center;
  height: 100%;
  align-self: center;
  font-weight: bold;
`;

export const Phone = styled.div`
  flex: 3;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  font-weight: bold;

  @media only screen and (max-width: 1000px) {
    flex: 2;
  }
`;

export const LinkStyled = styled.a`
  display: flex;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipse;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  height: 100%;
  font-size: 13px;
  color: #555555;

  &:hover {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    background: ${({ theme }) => theme.colors.header};
    color: #fff;
  }

  &:active {
    background: #000000;
    color: #fff;
  }

  @media only screen and (max-width: 1000px) {
    font-size: 13px !important;
  }
`;
